export default __webpack_public_path__ + "static/media/img5.40cfdf31.PNG";